module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1cc752c6971ba9ab2f98fec83509120e.png";